import { AUTH_PAGES_ROUTES, TEST_ENVIRONMENT_ROUTES } from "./routes";

// List of frontend routes the user will be able to access when using Schoolyear browser
export const schoolyearAllowedRoutes = [
  AUTH_PAGES_ROUTES.LOG_IN,
  AUTH_PAGES_ROUTES.VALIDATE,
  TEST_ENVIRONMENT_ROUTES.LANDING_PAGE,
  TEST_ENVIRONMENT_ROUTES.TEST_DETAILS_PAGE,
  TEST_ENVIRONMENT_ROUTES.TEST_EXERCISE_PAGE,
  TEST_ENVIRONMENT_ROUTES.TEST_EXERCISE_REVIEW_PAGE,
  TEST_ENVIRONMENT_ROUTES.TEST_COMPLETED_PAGE,
];
